/**
 * @param dateRange - an {@link ISODateRange}
 * @returns the equivalent range as a {@link TableStringFilterInput}, or null if none is found
 */
export const ISODateRangeToTimestampFilter = ({
    start,
    end,
}: ISODateRange): TableStringFilterInput | null => {
    if (start !== null && end !== null) {
        return {
            between: [start, end],
        };
    }

    if (start !== null) {
        return {
            gt: start,
        };
    }

    if (end !== null) {
        return {
            lt: end,
        };
    }

    return null;
};
